import React from "react";
import PropTypes from "prop-types";
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles(theme => ({
  select:{
      fontSize: '0.75rem',
  },
  formControl: {
    maxWidth: 300,
    margin: '0px',
    marginTop: '18px'
  },
  typography: {
    color: 'rgba(0, 0, 0, 0.54)',
    padding: 0,
    fontSize: '1rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    letterSpacing: '0.00938em',
    transition: 'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
  }
}));

const Tier = ({
  onChange,
  disabled,
  error,
  title,
  tier,
  tier_variations,
  tier_brands,
  inline,
  display,
  ...props
}) => {


const handleChange = event => {
  onChange(event, 'tiers')
}
return (
    <React.Fragment>
      {
        (display)
            ?
              <React.Fragment>
                <div className="row">
                  <div className="col-12">
                    <Typography variant="body2" className="mt-2">
                      {title}
                    </Typography>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    {(tier.last_tier_variation_id === '0' || tier.last_tier_variation_id === 0)
                      ?
                        <React.Fragment>
                          <FormControl className="" style={{fontSize: '0.75rem'}} name={tier.tier_type_id + ".tier_variation_brand_id"} >Marca
                            <Select native name={tier.tier_type_id + ".tier_variation_brand_id"}
                                inputProps={{
                                  name:tier.tier_type_id + ".tier_variation_brand_id",
                                  className:"tier_variation_brand_id"
                                }}
                                style={{minwidth: 120, fontSize: '0.75rem'}}
                                disabled={disabled}
                                value={tier.tier_variation_brand_id}
                                onChange={handleChange}
                                input={<Input id="grouped-native-select" name={tier.tier_type_id + '.tier_variation_brand_id'}/>}>
                                <option value="" />
                                {tier_brands.map((brand) =>
                                    <option id={brand.id} value={brand.id}>{brand.name}</option>
                                )}
                            </Select>
                          </FormControl>                        
                          <TextField
                            id={tier.tier_type_id + ".tier_variation_name"}
                            name={tier.tier_type_id + ".tier_variation_name"}
                            label="Nombre"
                            disabled={disabled}
                            type="text"
                            placeholder="Ingrese el nombre"
                            onChange={handleChange}
                            value={tier.tier_variation_name}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />

                          <TextField
                            id={tier.tier_type_id + ".tier_variation_size"}
                            name={tier.tier_type_id + ".tier_variation_size"}
                            label="Perfil"
                            disabled={disabled}
                            type="number"
                            placeholder="Ingrese el perfil"
                            onChange={handleChange}
                            value={tier.tier_variation_size}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />                                                  
                          <TextField
                            id={tier.tier_type_id + ".tier_variation_wheel"}
                            name={tier.tier_type_id + ".tier_variation_wheel"}
                            label="Rodado"
                            disabled={disabled}
                            type="number"
                            placeholder="Ingrese el rodado"
                            onChange={handleChange}
                            value={tier.tier_variation_wheel}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />                                                  

                          <TextField
                            id={tier.tier_type_id + ".tier_variation_anchor"}
                            name={tier.tier_type_id + ".tier_variation_anchor"}
                            label="Ancho"
                            disabled={disabled}
                            type="number"
                            placeholder="Ingrese el anchor"
                            onChange={handleChange}
                            value={tier.tier_variation_anchor}
                            margin="none"
                            className="mr-2 "
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{style:{fontSize: '0.75rem'}}} 
                          />                                                  
                        </React.Fragment>
                      :
                        <FormControl className="" style={{minwidth: 120, fontSize: '0.75rem'}} name={tier.tier_type_id + ".last_tier_variation_id"} >Modelo
                          <Select native name={tier.tier_type_id + ".last_tier_variation_id"}
                              inputProps={{
                                name:tier.tier_type_id + ".last_tier_variation_id",
                                className:"last_tier_variation_id"
                              }}
                              style={{minwidth: 120, fontSize: '0.75rem'}}
                              disabled={disabled}
                              value={tier.last_tier_variation_id}
                              onChange={handleChange}
                              input={<Input id="grouped-native-select" name={tier.tier_type_id + '.last_tier_variation_id'}/>}>
                              <option value="" />
                              <option value="0">Nuevo modelo</option>
                              {tier_variations.map((variation) =>
                                  <option id={variation.id} value={variation.id}>{variation.name} - {variation.size}x{variation.wheel}x{variation.anchor}</option>
                              )}
                          </Select>
                        </FormControl>
                    }
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-12">
                    <TextField
                      id={tier.tier_type_id + ".last_km_change"}
                      name={tier.tier_type_id + ".last_km_change"}
                      label="Últ. KM"
                      disabled={disabled}
                      type="number"
                      placeholder="Ingrese el últ.km"
                      onChange={handleChange}
                      value={tier.last_km_change}
                      margin="none"
                      className="mr-2 "
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{style:{minwidth: 120, fontSize: '0.75rem'}}} 
                    />
                    <TextField
                      id={tier.tier_type_id + ".last_date_change"}
                      name={tier.tier_type_id + ".last_date_change"}
                      label="Últ. Fecha"
                      disabled={disabled}
                      type="date"
                      placeholder="Ingrese la últ. fecha"
                      onChange={handleChange}
                      value={tier.last_date_change}
                      margin="none"
                      className="mr-2 "
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{style:{minwidth: 120, fontSize: '0.75rem'}}} 
                    />
                  </div>
                </div>
                <div className="row mt-1">
                  <div className="col-12">
                    <TextField
                      id={tier.tier_type_id + ".next_km_change"}
                      name={tier.tier_type_id + ".next_km_change"}
                      label="Próximo KM"
                      disabled={disabled}
                      type="number"
                      placeholder="Ingrese el próximo km"
                      onChange={handleChange}
                      value={tier.next_km_change}
                      margin="none"
                      className="mr-2 "
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{style:{minwidth: 120, fontSize: '0.75rem'}}} 
                    />
                    <TextField
                      id={tier.tier_type_id + ".next_date_change"}
                      name={tier.tier_type_id + ".next_date_change"}
                      label="Próxima Fecha"
                      disabled={disabled}
                      type="date"
                      placeholder="Ingrese la próxima. fecha"
                      onChange={handleChange}
                      value={tier.next_date_change}
                      margin="none"
                      className="mr-2 "
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{style:{minwidth: 120, fontSize: '0.75rem'}}} 
                    />
                  </div>        
                </div>
                <div className="row mt-1">
                  <div className="col-12">
                    <FormControl className="" style={{minwidth: 120, fontSize: '0.75rem'}} name={tier.tier_type_id + ".rotate_id"} >Rotar con
                      <Select native name={tier.tier_type_id + ".rotate_id"}
                          inputProps={{
                            name:tier.tier_type_id + ".rotate_id",
                            className:"rotate_id"
                          }}
                          style={{minwidth: 120, fontSize: '0.75rem'}}
                          disabled={disabled}
                          onChange={handleChange}
                          input={<Input id="grouped-native-select" name={tier.tier_type_id + '.rotate_id'}/>}>
                          <option value="" />
                          <option value="1">Delantera izquierda</option>
                          <option value="2">Delantera derecha</option>
                          <option value="3">Trasera izquierda</option>
                          <option value="4">Trasera derecha</option>
                          <option value="5">Auxilio</option>
                      </Select>
                    </FormControl>
                  </div>
                </div>

              </React.Fragment>
            :
              ''
      }
    </React.Fragment>
    )
}

Tier.defaultProps = {
  inline: false,
  display: true
}

export default Tier;

